// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ConfiguracoesSistema_DeleteResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /config/configuracoes_sistema/delete/{nome}
 *
 * Action endpoint with no payload — the model deletes the row and the
 * controller signals success via the envelope's `success` flag, emitting
 * `dados: null`. Mirrors ConfiguracoesSistemaFranquia_DeleteResponse.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type ConfiguracoesSistema_DeleteResponseDados = null;

export type ConfiguracoesSistema_DeleteResponse = ApiResponse<ConfiguracoesSistema_DeleteResponseDados>;

registerResponseContract('ConfiguracoesSistema_DeleteResponse', {})
